import React from "react";

const GalleryBanner = () => {
  return (
    <div className="breadcumb-section">
      <div className="breadcumb-wrapper">       
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcumb-content">
                <h1 className="breadcumb-title">Gallery</h1>
                <ul className="breadcumb-menu">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li className="text-white">/</li>
                  <li className="active">Gallery</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryBanner;
